import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 md:h-40">
          {/* Logo */}
          <div className="flex items-center px-2 md:px-6 py-2 md:py-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_903e5963-72e7-475f-b460-9902e41c4ee5/artifacts/h8peuqt0_8df8d676-d288-4871-a8e4-e2e9366a1aaa.png" 
              alt="PA Global Management & Consultancy" 
              className="h-16 md:h-40 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex flex-col items-end space-y-4">
            <div className="flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('about')}
                className="text-[hsl(215,65%,22%)] hover:text-[hsl(210,45%,45%)] font-semibold transition-colors duration-200"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-[hsl(215,65%,22%)] hover:text-[hsl(210,45%,45%)] font-semibold transition-colors duration-200"
              >
                Services
              </button>
              <Button 
                onClick={() => scrollToSection('contact')}
                className="bg-[hsl(210,45%,45%)] hover:bg-[hsl(215,65%,22%)] text-white font-semibold shadow-lg transition-all duration-200"
              >
                Contact Us
              </Button>
            </div>
            <div className="text-[hsl(210,45%,45%)] font-semibold text-sm tracking-wide">
              www.paglobalgroup.com
            </div>
          </div>

          {/* Mobile Menu Button - Right Side */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-[hsl(215,65%,22%)] hover:text-[hsl(210,45%,45%)] transition-colors p-2 rounded-lg"
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-6 animate-in slide-in-from-top bg-white border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('about')}
                className="text-[hsl(215,65%,22%)] hover:text-[hsl(210,45%,45%)] font-semibold text-left transition-colors duration-200"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-[hsl(215,65%,22%)] hover:text-[hsl(210,45%,45%)] font-semibold text-left transition-colors duration-200"
              >
                Services
              </button>
              <Button 
                onClick={() => scrollToSection('contact')}
                className="bg-[hsl(210,45%,45%)] hover:bg-[hsl(215,65%,22%)] text-white w-full shadow-lg transition-all duration-200"
              >
                Contact Us
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
